<template>
  <router-view />
</template>

<script>
export default {
  name: 'CompetitionId'
}
</script>
